import type { UUID } from "@/core/types";

import { useCreateNoteAddendum } from "../../api/mutations/useCreateNoteAddendum";

import { GeneralAddendumForm } from "./GeneralAddendumForm";

type CreateGeneralAddendumProps = {
  credentials: string | undefined;
  noteId: UUID;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

export function CreateGeneralAddendum({
  credentials,
  noteId,
  onCancel,
  onSuccess,
  patientId,
  signature,
}: CreateGeneralAddendumProps) {
  const { isPending, mutate } = useCreateNoteAddendum({ onSuccess });

  return (
    <GeneralAddendumForm
      isPending={isPending}
      mutate={(addendum) => mutate({ addendum, credentials, noteId, patientId, signature })}
      onCancel={onCancel}
    />
  );
}
